import sliceCreator from '../../index.jsx';
import {CREATE_VARIETY} from '../../../constants/index.jsx';
const _createVarietyAction = sliceCreator('CREATE_VARIETY', CREATE_VARIETY, 'post');

const { asyncAction: createVarietyAction, reducer, clearData: clearCreateVarietyAction } = _createVarietyAction;

export default reducer;

export {
    createVarietyAction,
    clearCreateVarietyAction
}